import { useState, useEffect } from 'react';
import LoadingSpinner from '@components/vehicle_search/loadingSpinner';
import type { WPCLOptions } from '@javascript/types/window';

type PaymentViewProps = {
  checkReserved: () => void;
  completeEnquiry: () => void;
  enquiry: { customerDetails: { shopper_id: string; worldpay_url: string } };
  stockReference: string;
  worldpayHelper: string;
  errorMessage?: string;
  orderBuilderToken?: string;
};

const PaymentView = ({
  checkReserved,
  completeEnquiry,
  enquiry,
  errorMessage,
  orderBuilderToken,
  stockReference,
  worldpayHelper,
}: PaymentViewProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const CUSTOM_OPTIONS: WPCLOptions = {
    type: 'iframe',
    url: enquiry.customerDetails.worldpay_url,
    target: 'custom-html',
    iframeHelperURL: worldpayHelper,
    debug: false,
    language: 'en',
    country: 'gb',
    resultCallback: function (responseData: { order: { status: string } }) {
      const status = responseData.order.status;
      switch (status) {
        case 'success':
          setIsLoading(true);
          completeEnquiry();
          break;
        case 'failure':
          // we dont want to send Enquiry when it fails right??
          break;
        case 'error':
          // we dont want to send Enquiry when it fails right??
          break;
        case 'cancelled_by_shopper':
          window.location.href = orderBuilderToken
            ? `/contact-us/cancelled/?stock_reference=${stockReference}&shopper_id=${enquiry.customerDetails.shopper_id}&token=${orderBuilderToken}`
            : `/contact-us/cancelled/?stock_reference=${stockReference}&shopper_id=${enquiry.customerDetails.shopper_id}`;
          break;
        default:
        // setTimeout(function() {
        //   reservationPaymentForm.destroy();
        //   this.createWorldpayObject();
        // }, 3000);
      }
    },
  };

  const createWorldpayObject = () => {
    const reservationPaymentForm = new window.WPCL.Library();
    reservationPaymentForm.setup(CUSTOM_OPTIONS);
    let event;
    if (typeof Event === 'function') {
      event = new Event('load');
    } else {
      // Hello, IE 11
      event = document.createEvent('Event');
      event.initEvent('load', true, true);
    }
    dispatchEvent(event);
  };

  useEffect(() => {
    checkReserved();
    createWorldpayObject();
  }, []);

  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <form action="https://secure.worldpay.com/wcc/purchase" method="POST">
        <section className="ch-pb--5">
          <p className="ch-mb--2 db-question">Summary</p>
          <div className="reserve-now__summary-box ch-ba--1 ch-bc--grey-3 ch-rounded--md ch-pa--2 sm:ch-bg--grey-1">
            <p className="ch-fs--3 ch-fw--500">Refundable deposit</p>
            <p className="ch-fs--2 ch-color--grey-6">
              No-commitment refundable deposit, holds your vehicle for 48 hours
            </p>
            <p className="ch-color--ac-pricing ch-fw--500 ch-fs--4 ch-ma--0">
              £99.00
            </p>
          </div>
        </section>
        <section className="db-section">
          <p className="ch-mb--2 db-question">Payment details</p>
          {errorMessage && (
            <p className="ch-text--bold ch-color--ac-red">{errorMessage}</p>
          )}
          <LoadingSpinner isLoading={isLoading} />
          <div
            className="db-payment-form"
            id="custom-html-wrapper"
            style={{ opacity: isLoading ? 0 : 1 }}
          >
            <div className="ch-card" id="custom-html" />
          </div>
        </section>
      </form>
    </div>
  );
};

export default PaymentView;
